import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { Stack, Typography } from "@mui/material";
import {
  BackArrowIcon,
  CloseDrawerIcon,
} from "../../components/ui-elements/svg-icons";
import { PostPetition } from "../../interface/api";
import PetitionOne from "../../components/posts/petition-1";
import PetitionTwo from "../../components/posts/petition-2";
import PetitionThree from "../../components/posts/petition-3";
import PetitionFour from "../../components/posts/petition-4";
import PetitionPreview from "../../components/posts/petition-preview";
import useResponsive from "../../hooks/useResponsive";

const PetitionReport = ({
  toggle_drawer,
  open_modal,
  close_petition_modal,
}: {
  open_modal: boolean;
  close_petition_modal: () => void;
  toggle_drawer: (newOpen: boolean) => () => void;
}) => {
  const [page_number, setPage_number] = React.useState(1);
  const isSmall = useResponsive("down", "sm", "xl");

  const handle_next = () => {
    setPage_number(page_number + 1);
  };
  const handle_prev = () => {
    setPage_number(page_number - 1);
  };
  const set_page_default = () => setPage_number(1);

  const [petition_data, setPetition_data] = React.useState<PostPetition>({
    target_signatures: "500",
    title: "",
    media: [],
    context: "",
    target_representative_ids: [],
    post_type: "petition",
  });

  const DrawerList = (
    <Box
      sx={{ width: isSmall ? "100%" : 500, mx: isSmall ? "auto" : "0px" }}
      role="presentation"
    >
      <Stack
        direction={"row"}
        alignItems="center"
        justifyContent={"space-between"}
        sx={{
          p: 2,
        }}
      >
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          {page_number === 5 && (
            <Button
              onClick={() => setPage_number(4)}
              sx={{ p: 0, m: 0, minWidth: 28 }}
            >
              <BackArrowIcon />
            </Button>
          )}
          <Typography variant="h4" color="black" sx={{ fontWeight: 600 }}>
            {page_number === 5 ? "Petition preview" : "Create Petition Report"}
          </Typography>
        </Stack>
        <Button onClick={toggle_drawer(false)}>
          <CloseDrawerIcon />
        </Button>
      </Stack>

      <Divider />
      <Box>
        {page_number === 1 && (
          <PetitionOne
            cancel={toggle_drawer(false)}
            next={handle_next}
            petition_data={petition_data}
            setPetition_data={setPetition_data}
          />
        )}
        {page_number === 2 && (
          <PetitionTwo
            prev={handle_prev}
            next={handle_next}
            petition_data={petition_data}
            setPetition_data={setPetition_data}
          />
        )}
        {page_number === 3 && (
          <PetitionThree
            prev={handle_prev}
            next={handle_next}
            petition_data={petition_data}
            setPetition_data={setPetition_data}
          />
        )}
        {page_number === 4 && (
          <PetitionFour
            prev={handle_prev}
            next={handle_next}
            petition_data={petition_data}
            setPetition_data={setPetition_data}
          />
        )}
        {page_number === 5 && (
          <PetitionPreview
            petition_data={petition_data}
            setPetition_data={setPetition_data}
            close_modal={close_petition_modal}
            set_page_default={set_page_default}
          />
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer open={open_modal} onClose={toggle_drawer(false)} anchor="right">
        {DrawerList}
      </Drawer>
    </div>
  );
};

export default PetitionReport;
